import { Line } from '@ant-design/plots';
import PropTypes from 'prop-types';
import { formatAnalysisDate, formatAnalysisTimestamp, getTrendTimeValue } from '../utils/analysis';

const formatTrendTooltipTitle = (item) => formatAnalysisTimestamp(item?.dateValue ?? item);

const AnalysisContentTrendChart = ({ dataSource }) => {
  const series = (dataSource || []).map((item) => ({
    ...item,
    dateValue: getTrendTimeValue(item.date),
  }));

  return (
    <Line
      width={1024}
      height={478}
      data={series}
      xField="dateValue"
      yField="value"
      colorField="metric"
      axis={{
        x: {
          title: false,
          labelFormatter: formatAnalysisDate,
        },
        y: { title: false },
      }}
      legend={{
        color: {
          layout: { justifyContent: 'center' },
          position: 'bottom',
        },
      }}
      scale={{
        x: { type: 'time' },
      }}
      tooltip={{
        title: formatTrendTooltipTitle,
      }}
    />
  );
};

AnalysisContentTrendChart.propTypes = {
  dataSource: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.number,
      metric: PropTypes.string,
      value: PropTypes.number,
    }),
  ),
};

AnalysisContentTrendChart.defaultProps = {
  dataSource: [],
};

export default AnalysisContentTrendChart;
